import React from "react";
import "./Attractions.css";
import photoFirstElement from "../../../assets/images/trasadladzieci.jpg"
import photoSecondElement from "../../../assets/images/trasadladorosłych.jpg"
import photoThirdElement from "../../../assets/images/trasazjazdowa.jpg"
import heightIcon from "../../../assets/icons/user-plus.svg"
import obstacleIcon from "../../../assets/icons/alert-octagon.svg"
import lengthIcon from "../../../assets/icons/activity.svg"


const Attractions = () =>{
return(
    <section className="section-attractions wrapper">
        <div className="attractions-element">
            <div className="element-img">
                <img src={photoFirstElement} alt="zdjęcie trasy dla dzieci"></img>
            </div>
            <div className="element-content">
                <div className="content-text">
                    <h3>Trasa dla dzieci</h3>
                    <p>Na podejmujących wyzwanie czekają między innymi: Kacza Kładka, Równoważnie, Chmurki, Pajęczyna, Iksy, Sanki, Tyrolka, Linki, Beczka, Most U, Kłoda, Wiszące Ścianki, Platformy, Obręcze i Belki a na koniec ziuuuu, Zjeżdżalnia!</p>
                </div>
                <div className="content-info">
                    <div className="info-box">
                        <div className="info-icon">
                            <img src={heightIcon} alt="icona wzrostu"></img>
                            <p>120cm</p>
                        </div>
                        <div className="info-title">
                            <p>minimalny wzrost</p>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="info-icon">
                            <img src={obstacleIcon} alt="icona przeszkód"></img>
                            <p>17</p>
                        </div>
                        <div className="info-title">
                        <p>przeszkód</p>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="info-icon">
                        <img src={lengthIcon} alt="icona długości"></img>
                        <p>129m</p>
                        </div>
                        <div className="info-title">
                        <p>długośc trasy</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="attractions-element">
            <div className="element-img second-element">
                <img src={photoSecondElement} alt="zdjęcie trasy dla dorosłych"></img>
            </div>
            <div className="element-content">
                <div className="content-text">
                    <h3>Trasa dla dorosłych</h3>
                    <p>Na odważnych czekają: Liny, Tyrolka, Trapezy, Most Birmański, Skok Indiański, Drabinki Linowe, Strzemiona, Huśtawka, Trawers (po sieci), Linoskoczek, a na koniec Miś Koala, szkoda, że nie można go pogłaskać.</p>
                </div>
                <div className="content-info">
                    <div className="info-box">
                        <div className="info-icon">
                            <img src={heightIcon} alt="icona wzrostu"></img>
                            <p>160cm</p>
                        </div>
                        <div className="info-title">
                            <p>minimalny wzrost</p>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="info-icon">
                            <img src={obstacleIcon} alt="icona przeszkód"></img>
                            <p>16</p>
                        </div>
                        <div className="info-title">
                        <p>przeszkód</p>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="info-icon">
                        <img src={lengthIcon} alt="icona długości"></img>
                        <p>185m</p>
                        </div>
                        <div className="info-title">
                        <p>długośc trasy</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="attractions-element">
            <div className="element-img">
                <img src={photoThirdElement} alt="zdjęcie trasy dla dzieci"></img>
            </div>
            <div className="element-content">
                <div className="content-text">
                    <h3>Trasa zjazdowa</h3>
                    <p>Trasa Tyrolkowa, składa się z 7 przeszkód wraz z wejściem i zejściem, a pomiędzy nimi samych zjazdów linowych, z których ostatni, najdłuższy, 60-metrowy biegnie nad powierzchnią parkowego stawu. Uwaga na szczypiące w łydki łabędzie! To oczywiście żart, ale sam zjazd nad wodą dostarcza niezapomnianych wrażeń.</p>
                </div>
                <div className="content-info">
                    <div className="info-box">
                        <div className="info-icon">
                            <img src={heightIcon} alt="icona wzrostu"></img>
                            <p>160cm</p>
                        </div>
                        <div className="info-title">
                            <p>minimalny wzrost</p>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="info-icon">
                            <img src={obstacleIcon} alt="icona przeszkód"></img>
                            <p>7</p>
                        </div>
                        <div className="info-title">
                        <p>przeszkód</p>
                        </div>
                    </div>
                    <div className="info-box">
                        <div className="info-icon">
                        <img src={lengthIcon} alt="icona długości"></img>
                        <p>185m</p>
                        </div>
                        <div className="info-title">
                        <p>długośc trasy</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
)
}

export default Attractions;